export default __webpack_public_path__ + "static/media/80percent.8dc6712e.svg";